export const SAVE_CATEGORY_MASTER = "SAVE_CATEGORY_MASTER"
export const SAVE_CATEGORY_MASTER_SUCCESS = "SAVE_CATEGORY_MASTER_SUCCESS"

export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST"
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS"

export const DELETE_CATEGORY_ID = "DELETE_CATEGORY_ID"
export const DELETE_CATEGORY_ID_SUCCESS = "DELETE_CATEGORY_ID_SUCCESS"

export const EDIT_CATEGORY_ID = "EDIT_CATEGORY_ID"
export const EDIT_CATEGORY_ID_SUCCESS = "EDIT_CATEGORY_ID_SUCCESS"

export const UPDATE_CATEGORY_ID = "UPDATE_CATEGORY_ID"
export const UPDATE_CATEGORY_ID_SUCCESS = "UPDATE_CATEGORY_ID_SUCCESS"

export const CATEGORY_API_ERROR_ACTION = "CATEGORY_API_ERROR_ACTION"


